import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { App, NavController } from 'ionic-angular';
import { Observable } from 'rxjs';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { CustomerGroup } from '../../app/models/CustomerGroup';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HttpErrorResponse } from '@angular/common/http';
import { Customer } from '../../app/models/Customer';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { TableDirective } from '../../directives/table-directive';
import { CustomerGroupDetailsPage } from '../customer-group-details/customer-group-details';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-customer-groups',
  templateUrl: 'customer-groups.html',
})
export class CustomerGroupsPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('customerGroupForm')
  private customerGroupForm: NgForm;

  private pageName: string = 'page-customer-groups';

  private customerGroups: CustomerGroup[];
  private customers: Customer[];
  private currentCustomerGroup: CustomerGroup = new CustomerGroup();
  private edit = false;

  private navControllerService: NavControllerService;

  constructor(
    private navCtrl: NavController,
    private backendService: PaytronBackendService,
    private app: App,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ionViewWillEnter() {
    this.customerGroups = [];
    this.getCustomerGroups();
  }

  ngOnDestroy(): void {}

  callback() {}

  private getCustomerGroups() {
    let customerGroupList: Observable<CustomerGroup[]> = this.backendService.getCustomerGroups();
    customerGroupList.subscribe((customergroups) => {
      this.customerGroups = customergroups;
      this.table.refreshTable();
    });
  }

  inserCustomerGroup() {
    this.currentCustomerGroup = new CustomerGroup();
    this.showCustomerGroupDetails(this.currentCustomerGroup);
  }

  editCustomerGroup(customerGroup) {
    this.edit = true;
    this.currentCustomerGroup = customerGroup;
    this.showCustomerGroupDetails(this.currentCustomerGroup);
  }

  deleteCustomerGroup() {
    let response = this.backendService.deleteCustomerGroup(this.currentCustomerGroup);

    response.subscribe(
      (data) => {
        this.getCustomerGroups();
        this.closeConfirmModal();
      },
      (err: HttpErrorResponse) => {
        this.closeConfirmModal();
      }
    );
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  showConfirmModal(customerGroup) {
    this.currentCustomerGroup = customerGroup;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showCustomersPage() {
    this.navControllerService.showCustomersPage();
  }

  showCustomerGroupDetails(customerGroup: CustomerGroup) {
    this.navControllerService.showCustomerGroupDetails(customerGroup.uuid);
  }
}



// WEBPACK FOOTER //
// ./src/pages/customer-groups/customer-groups.ts